import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'path',
      d: 'M-0.5,-3.5h1v0.5h-1zM-6,-1.5h0.5v0.5h-0.5zM-6.5,-1h1.5v0.5h-1.5zM6,-1h1v0.5h-1zM-6.5,-0.5h2.5v0.5h-2.5zM6,-0.5h0.5v0.5h-0.5zM-5.5,0h2.5v0.5h-2.5zM3,0h1.5v0.5h-1.5zM5,0h0.5v0.5h-0.5zM-4.5,0.5h2.5v0.5h-2.5zM2,0.5h2.5v0.5h-2.5zM-3.5,1h2.5v0.5h-2.5zM1,1h2.5v0.5h-2.5zM-2.5,1.5h5v0.5h-5zM-1.5,2h3v0.5h-3zM-0.5,2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['wall', 0.73],
      ],
      d: 'M-5.5,-5h1v0.5h-1zM-5.5,-4.5h2v0.5h-2zM-5.5,-4h3.5v0.5h-3.5zM-5.5,-3.5h1.5v2h-1.5zM-2.5,-3.5h2v0.5h-2zM2.5,-3.5h0.5v0.5h-0.5zM-1.5,-3h1.5v3.5h-1.5zM1.5,-3h0.5v0.5h-0.5zM3,-3h0.5v1h-0.5zM1,-2h0.5v1h-0.5zM-5,-1.5h1v0.5h-1zM3,-1.5h0.5v0.5h-0.5zM1,-0.5h0.5v0.5h-0.5zM-1,0.5h1v0.5h-1z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['wall', 0.7],
      ],
      d: 'M5.5,-6h0.5v0.5h-0.5zM4.5,-5.5h1.5v0.5h-1.5zM3.5,-5h2.5v0.5h-2.5zM-3.5,-4.5h0.5v0.5h-0.5zM2.5,-4.5h3.5v0.5h-3.5zM-2,-4h0.5v0.5h-0.5zM1.5,-4h4.5v0.5h-4.5zM0.5,-3.5h2v0.5h-2zM3.5,-3.5h2.5v0.5h-2.5zM0,-3h1.5v0.5h-1.5zM3.5,-3h0.5v1h-0.5zM5.5,-3h0.5v0.5h-0.5zM0,-2.5h1v2.5h-1zM2,-1h1.5v0.5h-1.5zM1.5,-0.5h1.5v0.5h-1.5zM0,0h2v0.5h-2zM0,0.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M-3.5,-3.5h0.5v0.5h-0.5zM-3.5,-3h1.5v0.5h-1.5zM-3.5,-2.5h2v2h-2zM4,-2.5h0.5v0.5h-0.5zM-2.5,-0.5h1v0.5h-1z',
    },
    {
      paint: 'sail',
      d: 'M3,-3.5h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM1,-2.5h1v0.5h-1zM2.5,-2h1v0.5h-1zM1.5,-1.5h0.5v0.5h-0.5zM2.5,-1.5h0.5v0.5h-0.5zM1,-1h1v0.5h-1z',
    },
    {
      paint: 'fence',
      d: 'M2,-3h0.5v0.5h-0.5zM2,-2.5h1v0.5h-1zM1.5,-2h1v0.5h-1zM-5.5,-1.5h0.5v0.5h-0.5zM2,-1.5h0.5v0.5h-0.5zM-5,-1h1v0.5h-1zM-4,-0.5h1v0.5h-1zM3.5,-0.5h0.5v0.5h-0.5zM-3,0h1v0.5h-1zM2.5,0h0.5v0.5h-0.5zM-2,0.5h1v0.5h-1zM1.5,0.5h0.5v0.5h-0.5zM-0.5,1h1v0.5h-1z',
    },
    {
      paint: [
        ['barrel', 0.38],
        ['trunk', 0.62],
      ],
      d: 'M4.5,-2h0.5v0.5h-0.5zM4.5,-1.5h1v0.5h-1zM4,-1h1.5v1h-1.5zM-3,-0.5h0.5v0.5h-0.5zM-2,0h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['barrel', 0.27],
        ['shadow', 0.3],
        ['trunk', 0.44],
      ],
      d: 'M4.5,-2.5h1.5v0.5h-1.5zM5,-2h1v0.5h-1zM5.5,-1.5h0.5v1h-0.5z',
    },
    {
      paint: [
        ['barrel', 0.28],
        ['sail', 0.27],
        ['trunk', 0.45],
      ],
      d: 'M-4,-3.5h0.5v3h-0.5zM-3,-3.5h0.5v0.5h-0.5zM-2,-3h0.5v0.5h-0.5zM4,-3h1.5v0.5h-1.5zM3.5,-2h1v1h-1zM3.5,-1h0.5v0.5h-0.5zM3,-0.5h0.5v0.5h-0.5zM2,0h0.5v0.5h-0.5zM1,0.5h0.5v0.5h-0.5zM0.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['thatch', 0.7],
      ],
      d: 'M-4.5,-9.5h0.5v0.5h-0.5zM-1.5,-9h0.5v1h-0.5zM-5,-8.5h0.5v0.5h-0.5zM2,-8.5h0.5v1h-0.5zM-7,-7.5h2v0.5h-2zM4.5,-7.5h0.5v0.5h-0.5zM-6,-7h0.5v0.5h-0.5zM-4.5,-7h0.5v0.5h-0.5zM-2,-7h0.5v1.5h-0.5zM1.5,-7h1.5v0.5h-1.5zM6,-7h1.5v0.5h-1.5zM-7.5,-6.5h1.5v0.5h-1.5zM5,-6.5h2v0.5h-2zM-7,-6h2v0.5h-2zM4,-6h1.5v0.5h-1.5zM-6,-5.5h0.5v0.5h-0.5zM-5,-5.5h1v0.5h-1zM2.5,-5.5h2v0.5h-2zM-4,-5h1v0.5h-1zM2,-5h1.5v0.5h-1.5zM-3,-4.5h2v0.5h-2zM0.5,-4.5h2v0.5h-2zM-1.5,-4h3v0.5h-3zM5.5,-0.5h0.5v0.5h-0.5zM4.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'thatch',
      d: 'M-0.5,-11h1v0.5h-1zM-3.5,-10.5h1v0.5h-1zM2,-10.5h1v0.5h-1zM-5,-10h1.5v0.5h-1.5zM1.5,-10h3v0.5h-3zM-5.5,-9.5h0.5v0.5h-0.5zM1.5,-9.5h4v0.5h-4zM-6.5,-9h1v0.5h-1zM1,-9h5v0.5h-5zM-7,-8.5h1v0.5h-1zM1,-8.5h1v0.5h-1zM2.5,-8.5h4v0.5h-4zM-7,-8h0.5v0.5h-0.5zM0.5,-8h1.5v0.5h-1.5zM2.5,-8h5v0.5h-5zM-7.5,-7.5h0.5v0.5h-0.5zM0.5,-7.5h4v0.5h-4zM5,-7.5h2.5v0.5h-2.5zM-7.5,-7h1.5v0.5h-1.5zM0.5,-7h1v0.5h-1zM3,-7h3v0.5h-3zM-6,-6.5h1.5v0.5h-1.5zM0,-6.5h5v0.5h-5zM-5,-6h1.5v0.5h-1.5zM0,-6h4v0.5h-4zM-4,-5.5h1.5v0.5h-1.5zM0,-5.5h2.5v0.5h-2.5zM-3,-5h1.5v0.5h-1.5zM0,-5h2v0.5h-2zM-1,-4.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['thatch', 0.73],
      ],
      d: 'M-2.5,-10.5h4.5v0.5h-4.5zM-3.5,-10h5v0.5h-5zM-5,-9.5h0.5v0.5h-0.5zM-4,-9.5h5.5v0.5h-5.5zM-5.5,-9h4v0.5h-4zM-1,-9h2v1h-2zM-6,-8.5h1v0.5h-1zM-4.5,-8.5h3v0.5h-3zM-6.5,-8h7v0.5h-7zM-5,-7.5h5.5v0.5h-5.5zM-5.5,-7h1v0.5h-1zM-4,-7h2v0.5h-2zM-1.5,-7h2v0.5h-2zM-4.5,-6.5h2.5v0.5h-2.5zM-1.5,-6.5h1.5v1h-1.5zM-3.5,-6h1.5v0.5h-1.5zM-5.5,-5.5h0.5v0.5h-0.5zM-2.5,-5.5h2.5v0.5h-2.5zM-4.5,-5h0.5v0.5h-0.5zM-1.5,-5h1.5v0.5h-1.5zM-1,1h0.5v0.5h-0.5z',
    },
  ],
  pixels: 586,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'path',
      d: 'M-0.5,-3.5h1v0.5h-1zM-6,-1.5h0.5v0.5h-0.5zM-6.5,-1h1.5v0.5h-1.5zM5,-1h2v0.5h-2zM-6.5,-0.5h2.5v0.5h-2.5zM4,-0.5h2.5v0.5h-2.5zM-5.5,0h2.5v0.5h-2.5zM3,0h2.5v0.5h-2.5zM-4.5,0.5h2.5v0.5h-2.5zM2,0.5h2.5v0.5h-2.5zM-3.5,1h2.5v0.5h-2.5zM1,1h2.5v0.5h-2.5zM-2.5,1.5h5v0.5h-5zM-1.5,2h3v0.5h-3zM-0.5,2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['wall', 0.73],
      ],
      d: 'M-5.5,-5h0.5v0.5h-0.5zM-4,-4.5h0.5v0.5h-0.5zM-3.5,-4h1.5v0.5h-1.5zM-2.5,-3.5h2v0.5h-2zM2.5,-3.5h0.5v0.5h-0.5zM-1.5,-3h1.5v3.5h-1.5zM1.5,-3h0.5v0.5h-0.5zM3,-3h0.5v1h-0.5zM-5.5,-2h1.5v0.5h-1.5zM1,-2h0.5v1h-0.5zM-5,-1.5h1v0.5h-1zM3,-1.5h0.5v0.5h-0.5zM1,-0.5h0.5v0.5h-0.5zM-1,0.5h1v0.5h-1z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['wall', 0.7],
      ],
      d: 'M5,-5.5h1v0.5h-1zM3.5,-5h2.5v0.5h-2.5zM-3.5,-4.5h0.5v0.5h-0.5zM2.5,-4.5h3.5v0.5h-3.5zM-4,-4h0.5v0.5h-0.5zM-2,-4h0.5v0.5h-0.5zM1.5,-4h4.5v0.5h-4.5zM0.5,-3.5h2v0.5h-2zM3.5,-3.5h2.5v2h-2.5zM0,-3h1.5v0.5h-1.5zM-4,-2.5h0.5v1.5h-0.5zM0,-2.5h1v2.5h-1zM3.5,-1.5h2v0.5h-2zM2,-1h2.5v0.5h-2.5zM1.5,-0.5h2v0.5h-2zM0,0h2v0.5h-2zM0,0.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M-3.5,-3.5h0.5v0.5h-0.5zM-3,-3h1v0.5h-1zM-3.5,-2.5h2v2h-2zM-3,-0.5h1.5v0.5h-1.5zM-2,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'sail',
      d: 'M3,-3.5h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM1,-2.5h1v0.5h-1zM2.5,-2h1v0.5h-1zM1.5,-1.5h0.5v0.5h-0.5zM2.5,-1.5h0.5v0.5h-0.5zM1,-1h1v0.5h-1z',
    },
    {
      paint: 'fence',
      d: 'M-3,-3.5h0.5v0.5h-0.5zM-2,-3h0.5v0.5h-0.5zM2,-3h0.5v0.5h-0.5zM2,-2.5h1v0.5h-1zM1.5,-2h1v0.5h-1zM-5.5,-1.5h0.5v0.5h-0.5zM2,-1.5h0.5v0.5h-0.5zM5.5,-1.5h0.5v0.5h-0.5zM-5,-1h1.5v0.5h-1.5zM4.5,-1h0.5v0.5h-0.5zM-4,-0.5h1v0.5h-1zM3.5,-0.5h0.5v0.5h-0.5zM-3,0h1v0.5h-1zM2,0h1v0.5h-1zM-2,0.5h1v0.5h-1zM1,0.5h1v0.5h-1zM-0.5,1h1.5v0.5h-1.5z',
    },
    {
      paint: 'haystack',
      d: 'M-6,-4.5h1.5v0.5h-1.5zM-6.5,-4h2.5v0.5h-2.5zM-6.5,-3.5h3v0.5h-3zM-6,-3h2.5v0.5h-2.5zM-6,-2.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['thatch', 0.7],
      ],
      d: 'M-1.5,-8.5h0.5v0.5h-0.5zM2,-8h0.5v0.5h-0.5zM-7,-7.5h1v0.5h-1zM-5.5,-7.5h0.5v0.5h-0.5zM4.5,-7.5h0.5v0.5h-0.5zM-6,-7h0.5v0.5h-0.5zM-4.5,-7h0.5v0.5h-0.5zM-2,-7h0.5v1.5h-0.5zM1.5,-7h1.5v0.5h-1.5zM7,-7h1.5v0.5h-1.5zM-8.5,-6.5h1.5v0.5h-1.5zM5.5,-6.5h2v0.5h-2zM-7.5,-6h2v0.5h-2zM4.5,-6h2v0.5h-2zM-6.5,-5.5h2v0.5h-2zM2.5,-5.5h2.5v0.5h-2.5zM-4.5,-5h1.5v0.5h-1.5zM2,-5h1.5v0.5h-1.5zM-3,-4.5h2v0.5h-2zM1,-4.5h1.5v0.5h-1.5zM-1.5,-4h3v0.5h-3zM-3.5,-3h0.5v0.5h-0.5z',
    },
    {
      paint: 'thatch',
      d: 'M-4,-10h2v0.5h-2zM1,-10h2.5v0.5h-2.5zM-5.5,-9.5h2v0.5h-2zM1.5,-9.5h3.5v0.5h-3.5zM-6.5,-9h1.5v0.5h-1.5zM1.5,-9h5v0.5h-5zM-7.5,-8.5h1.5v0.5h-1.5zM1,-8.5h6.5v0.5h-6.5zM-8,-8h1v0.5h-1zM1,-8h1v0.5h-1zM2.5,-8h5.5v0.5h-5.5zM-8.5,-7.5h0.5v0.5h-0.5zM0.5,-7.5h4v0.5h-4zM5,-7.5h3.5v0.5h-3.5zM-8.5,-7h2v0.5h-2zM0.5,-7h1v0.5h-1zM3,-7h4v0.5h-4zM-7,-6.5h1.5v0.5h-1.5zM0,-6.5h5.5v0.5h-5.5zM-5.5,-6h1.5v0.5h-1.5zM0,-6h4.5v0.5h-4.5zM-4.5,-5.5h2v0.5h-2zM0,-5.5h2.5v0.5h-2.5zM-3,-5h1.5v0.5h-1.5zM0,-5h2v0.5h-2zM-1,-4.5h2v0.5h-2z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['thatch', 0.73],
      ],
      d: 'M-2,-10h3v0.5h-3zM-3.5,-9.5h5v0.5h-5zM-5,-9h6.5v0.5h-6.5zM-6,-8.5h4.5v0.5h-4.5zM-1,-8.5h2v0.5h-2zM-7,-8h8v0.5h-8zM-8,-7.5h1v0.5h-1zM-6,-7.5h0.5v0.5h-0.5zM-5,-7.5h5.5v0.5h-5.5zM-6.5,-7h0.5v0.5h-0.5zM-5.5,-7h1v0.5h-1zM-4,-7h2v0.5h-2zM-1.5,-7h2v0.5h-2zM-5.5,-6.5h3.5v0.5h-3.5zM-1.5,-6.5h1.5v1h-1.5zM-4,-6h2v0.5h-2zM-2.5,-5.5h2.5v0.5h-2.5zM-5,-5h0.5v0.5h-0.5zM-1.5,-5h1.5v0.5h-1.5zM-4.5,-4.5h0.5v0.5h-0.5zM-4.5,-2.5h0.5v0.5h-0.5zM-1,1h0.5v0.5h-0.5z',
    },
  ],
  pixels: 594,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'path',
      d: 'M-0.5,-3.5h1v0.5h-1zM-6,-1.5h0.5v0.5h-0.5zM-6.5,-1h1.5v0.5h-1.5zM6,-1h1v0.5h-1zM-6.5,-0.5h2.5v0.5h-2.5zM6,-0.5h0.5v0.5h-0.5zM-5.5,0h2.5v0.5h-2.5zM3,0h1.5v0.5h-1.5zM5,0h0.5v0.5h-0.5zM-4.5,0.5h2.5v0.5h-2.5zM2,0.5h2.5v0.5h-2.5zM-3.5,1h2.5v0.5h-2.5zM1,1h2.5v0.5h-2.5zM-2.5,1.5h5v0.5h-5zM-1.5,2h3v0.5h-3zM-0.5,2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['wall', 0.73],
      ],
      d: 'M-5,-5h0.5v0.5h-0.5zM-5,-4.5h2v0.5h-2zM-5.5,-4h3.5v0.5h-3.5zM-5.5,-3.5h1.5v2h-1.5zM-2.5,-3.5h2v0.5h-2zM2.5,-3.5h0.5v0.5h-0.5zM-1.5,-3h1.5v3.5h-1.5zM1.5,-3h0.5v0.5h-0.5zM3,-3h0.5v1h-0.5zM1,-2h0.5v1h-0.5zM-5,-1.5h1v0.5h-1zM3,-1.5h0.5v0.5h-0.5zM1,-0.5h0.5v0.5h-0.5zM-1,0.5h1v0.5h-1z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['wall', 0.7],
      ],
      d: 'M5.5,-6h0.5v0.5h-0.5zM4.5,-5.5h1.5v0.5h-1.5zM-4.5,-5h0.5v0.5h-0.5zM3.5,-5h2.5v0.5h-2.5zM-5.5,-4.5h0.5v0.5h-0.5zM2.5,-4.5h3.5v0.5h-3.5zM-2,-4h0.5v0.5h-0.5zM1.5,-4h4.5v0.5h-4.5zM0.5,-3.5h2v0.5h-2zM3.5,-3.5h2.5v0.5h-2.5zM0,-3h1.5v0.5h-1.5zM3.5,-3h0.5v1h-0.5zM5.5,-3h0.5v0.5h-0.5zM0,-2.5h1v2.5h-1zM2,-1h1.5v0.5h-1.5zM1.5,-0.5h1.5v0.5h-1.5zM0,0h2v0.5h-2zM0,0.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M-3.5,-3.5h0.5v0.5h-0.5zM-3.5,-3h1.5v0.5h-1.5zM-3.5,-2.5h2v2h-2zM4,-2.5h0.5v0.5h-0.5zM-2.5,-0.5h1v0.5h-1z',
    },
    {
      paint: 'sail',
      d: 'M3,-3.5h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM1,-2.5h1v0.5h-1zM2.5,-2h1v0.5h-1zM1.5,-1.5h0.5v0.5h-0.5zM2.5,-1.5h0.5v0.5h-0.5zM1,-1h1v0.5h-1z',
    },
    {
      paint: 'fence',
      d: 'M2,-3h0.5v0.5h-0.5zM2,-2.5h1v0.5h-1zM1.5,-2h1v0.5h-1zM-5.5,-1.5h0.5v0.5h-0.5zM2,-1.5h0.5v0.5h-0.5zM-5,-1h1v0.5h-1zM-4,-0.5h1v0.5h-1zM3.5,-0.5h0.5v0.5h-0.5zM-3,0h1v0.5h-1zM2.5,0h0.5v0.5h-0.5zM-2,0.5h1v0.5h-1zM1.5,0.5h0.5v0.5h-0.5zM-0.5,1h1v0.5h-1z',
    },
    {
      paint: [
        ['barrel', 0.38],
        ['trunk', 0.62],
      ],
      d: 'M4.5,-2h0.5v0.5h-0.5zM4.5,-1.5h1v0.5h-1zM4,-1h1.5v1h-1.5zM-3,-0.5h0.5v0.5h-0.5zM-2,0h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['barrel', 0.27],
        ['shadow', 0.3],
        ['trunk', 0.44],
      ],
      d: 'M4.5,-2.5h1.5v0.5h-1.5zM5,-2h1v0.5h-1zM5.5,-1.5h0.5v1h-0.5z',
    },
    {
      paint: [
        ['barrel', 0.28],
        ['sail', 0.27],
        ['trunk', 0.45],
      ],
      d: 'M-4,-3.5h0.5v3h-0.5zM-3,-3.5h0.5v0.5h-0.5zM-2,-3h0.5v0.5h-0.5zM4,-3h1.5v0.5h-1.5zM3.5,-2h1v1h-1zM3.5,-1h0.5v0.5h-0.5zM3,-0.5h0.5v0.5h-0.5zM2,0h0.5v0.5h-0.5zM1,0.5h0.5v0.5h-0.5zM0.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['thatch', 0.7],
      ],
      d: 'M-4.5,-10h0.5v0.5h-0.5zM-1.5,-9.5h0.5v1h-0.5zM-5,-9h0.5v0.5h-0.5zM2,-9h0.5v1h-0.5zM-5.5,-8h0.5v0.5h-0.5zM-7,-7.5h1.5v0.5h-1.5zM4.5,-7.5h0.5v0.5h-0.5zM-4.5,-7h0.5v0.5h-0.5zM-2,-7h0.5v1h-0.5zM1.5,-7h1.5v0.5h-1.5zM5.5,-7h1.5v0.5h-1.5zM-7,-6.5h1v0.5h-1zM4.5,-6.5h2v0.5h-2zM-6.5,-6h0.5v0.5h-0.5zM3.5,-6h2v0.5h-2zM-5,-5.5h1v0.5h-1zM2.5,-5.5h2v0.5h-2zM-4,-5h1v0.5h-1zM1.5,-5h2v0.5h-2zM-2.5,-4.5h1v0.5h-1zM0.5,-4.5h2v0.5h-2zM-1.5,-4h3v0.5h-3zM5.5,-0.5h0.5v0.5h-0.5zM4.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'thatch',
      d: 'M-2.5,-11.5h0.5v0.5h-0.5zM0,-11.5h2v0.5h-2zM-4,-11h1v0.5h-1zM2,-11h1.5v0.5h-1.5zM-5,-10.5h1v0.5h-1zM1.5,-10.5h2.5v0.5h-2.5zM-5,-10h0.5v0.5h-0.5zM1.5,-10h3.5v0.5h-3.5zM-5.5,-9.5h0.5v0.5h-0.5zM1,-9.5h4.5v0.5h-4.5zM-6,-9h0.5v0.5h-0.5zM1,-9h1v1h-1zM2.5,-9h3.5v0.5h-3.5zM-6.5,-8.5h0.5v0.5h-0.5zM2.5,-8.5h4v0.5h-4zM-7,-8h0.5v0.5h-0.5zM0.5,-8h6.5v0.5h-6.5zM0.5,-7.5h4v0.5h-4zM5,-7.5h2v0.5h-2zM-7,-7h1v0.5h-1zM0,-7h1.5v0.5h-1.5zM3,-7h2.5v0.5h-2.5zM-5,-6.5h0.5v0.5h-0.5zM0,-6.5h4.5v0.5h-4.5zM-5,-6h1.5v0.5h-1.5zM0,-6h3.5v0.5h-3.5zM-4,-5.5h2v0.5h-2zM0,-5.5h2.5v0.5h-2.5zM-3,-5h2v0.5h-2zM0,-5h1.5v0.5h-1.5zM-1.5,-4.5h2v0.5h-2z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['thatch', 0.73],
      ],
      d: 'M-2,-11.5h2v0.5h-2zM-3,-11h5v0.5h-5zM-4,-10.5h5.5v1h-5.5zM-5,-9.5h3.5v0.5h-3.5zM-1,-9.5h2v1h-2zM-5.5,-9h0.5v0.5h-0.5zM-4.5,-9h3v0.5h-3zM-6,-8.5h7v0.5h-7zM-6.5,-8h1v0.5h-1zM-5,-8h5.5v1h-5.5zM-5,-7h0.5v0.5h-0.5zM-4,-7h2v0.5h-2zM-1.5,-7h1.5v1h-1.5zM-4.5,-6.5h2.5v0.5h-2.5zM-3.5,-6h3.5v0.5h-3.5zM-2,-5.5h2v0.5h-2zM-1,-5h1v0.5h-1zM-3,-4.5h0.5v0.5h-0.5zM-1,1h0.5v0.5h-0.5z',
    },
    { paint: 'chimney', d: 'M-5.5,-7.5h0.5v0.5h-0.5zM-6,-7h1v2.5h-1zM-6,-4.5h0.5v0.5h-0.5z' },
  ],
  pixels: 606,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
